import { useState } from 'react';
import axios from 'axios';
import { API_BASE_URL as API } from '@/lib/apiBase';
import OTPEntry from './OTPEntry';

export default function MobileLinkPrompt({ account, accountType }) {
  const [dismissed, setDismissed] = useState(false);
  const [open, setOpen] = useState(false);
  const [error, setError] = useState('');
  if (!account || account.phone_verified || account.mobile_link_prompt_dismissed || dismissed) return null;
  return <aside className="m-4 rounded-xl border bg-orange-50 p-4" aria-label="Link mobile number">
    <p>Add your mobile number for faster sign-in via WhatsApp.</p>
    <button className="btn-outline mr-3 mt-3" onClick={() => setOpen(value => !value)}>Add mobile number</button>
    <button className="underline" onClick={async () => {
      try { await axios.post(`${API}/otp/link-prompt/dismiss?account_type=${accountType}`, {}, { withCredentials: true }); setDismissed(true); }
      catch { setError('Could not save your preference. Please try again.'); }
    }}>Dismiss</button>
    {error && <p role="alert">{error}</p>}
    {open && <OTPEntry accountType={accountType} onLinked={() => setDismissed(true)} />}
  </aside>;
}
